import './../Legal.scss';

import React from 'react';

import A from 'components/A';
import H2 from 'components/H2';
import H3 from 'components/H3';
import PageContent from 'components/PageContent';

export default class PrivacyPolicy extends React.Component {
    render() {
        return (
            <PageContent className="privacy-policy legal">
                <H2>
                    The Hunt Agency, LLC<br />
                    Privacy Policy
                </H2>

                <p>
                    This notice describes the Privacy Policy that applies to all information collected or submitted when a user (“you” or “User”) uses the website located at thehunt.agency as it may change from time to time (“Website”). The Website is owned and operated by The Hunt Agency, LLC, a Minnesota limited liability company (“we” or “us”). Any terms not expressly defined in this Privacy Policy will have the meanings assigned them in the Terms and Conditions.
                </p>

                <H3>WHAT WE DO</H3>
                <p>
                    We provide a platform through which freelancers, primarily those in the advertising and design industries (each a “Freelancer”), can connect with companies (each a “Company”) looking to engage Freelancer services on one or more projects or on-going engagements.
                </p>

                <H3>THE INFORMATION WE COLLECT</H3>
                <p>
                    Each User must create a user account to use the services available on the Website (the “Services”).
                </p>

                <strong>A.  Account Creation</strong><br />
                To create a Freelancer account, each User must provide:
                <ul>
                    <li>First name</li>
                    <li>Last name</li>
                    <li>Role / Position</li>
                    <li>Email address</li>
                    <li>Password</li>
                </ul>

                To create a Company account, each User must provide
                <ul>
                    <li>First name</li>
                    <li>Last name</li>
                    <li>Company</li>
                    <li>Email address</li>
                    <li>Password</li>
                </ul>

                Depending on whether you register as a Freelancer or as a Company, we may also request the following information, all of which is optional:
                <ul>
                    <li>Phone number</li>
                    <li>Website</li>
                    <li>Profile picture</li>
                    <li>LinkedIn</li>
                    <li>Dribble</li>
                    <li>Twitter</li>
                    <li>Facebook</li>
                    <li>Instagram</li>
                    <li>Github</li>
                    <li>About, narrative</li>
                    <li>Years of experience</li>
                    <li>Industry experience</li>
                    <li>Brand experience</li>
                </ul>

                <p>
                    <strong>B.  Direct Communication</strong><br />
                    We also collect information if a User contacts us for support or help, or otherwise communicates with us. The information we collect enables us to customize and enhance the services we provide to the User. In addition, we may use the information the User submits to communicate with the User about our news, events, promotions and new products. Each User may opt in or opt out at any time to receiving direct notifications from us, including account updates, new messages, and billing reminders.
                </p>

                <p>
                    <strong>C.  Cookies</strong><br />
                    A cookie is a small file that asks permission to be placed on a computer's hard drive. Once a User agrees, the file is added and the cookie helps analyze web traffic or lets the User know when the User visits a particular site. Cookies allow web applications to respond to each User as an individual. The web application can tailor its operations to a User’s needs, likes and dislikes by gathering and remembering information about the User’s preferences.
                </p>

                <p>
                    We use traffic log cookies to identify which pages are being used. This helps us analyze data about web page traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes.  After such analysis is complete, the data is removed from the system.
                </p>

                <p>
                    We may also use "pixel tags," "web beacons," "clear GIFs" or similar means (individually or collectively "Pixel Tags") in connection with emails that we send to our users in order to collect usage data. We use Pixel Tags, other technologies and the information we collect to count users who have visited certain pages on our Website, to deliver branded services and to help determine the effectiveness of promotional or advertising campaigns.
                </p>

                <p>
                    Overall, cookies help us provide each User with a better website, by enabling us to monitor which pages the User finds useful. Cookies do not give us access to a computer or any information about a particular User, other than the data the User chooses to share with us.
                </p>

                <p>
                    A User may decline cookies, if permitted by the User’s browser, although doing so may affect the performance or ability to use certain features.
                </p>

                <H3>COLLECTION OF INFORMATION FROM CHILDREN</H3>
                <p>
                    We comply with the Children's Online Privacy Protection Act, which requires us to notify and obtain consent from a parent or guardian before we collect, use and disclose the personal information of anyone under 13 years of age. Each User must be at least 18 years of age in order to use the Website. We do not knowingly collect any personal information from young people under the age of 13 without such consent and if we learn that we have inadvertently done so, we will promptly delete it.
                </p>

                <H3>THE WAY WE USE INFORMATION</H3>
                <p>
                    We are the sole owners of the information collected on, from or in conjunction with the Website. We only have access to and collect the information that Users voluntarily give us by their direct contact (via the sign-up portal, Website, or email). We will not sell or rent User information to anyone. We use the information we collect to operate and improve our services, such as making new content available to Users at a later time on any device that they use to access the Website.
                </p>

                <p>
                    We use non-identifying, aggregated information to analyze the manner in which the Website is used. Such aggregated information includes the manner in which content has been accessed, saved and shared. We may use aggregated information to offer a list of top sites or content, to make recommendations to our users, to report on usage and trends, to improve the products and services that we offer, or to develop new products and services. We may also use non-identifying, non-aggregated information to deliver tailored advertisements to Users.
                </p>

                <H3>SHARING OF INFORMATION</H3>
                <p>
                    Except as set forth in the Terms of Use, we do not share any personally identifiable information without a User’s express agreement. Personally identifiable information means information that can be used on its own or in conjunction with other information to identify an individual. Each User is responsible for assessing whether the User wants to make personally identifiable information available to other Users through the Website or by engaging in the services we offer. We are not responsible for any such disclosure if it is allowed pursuant to the Terms of Use.
                </p>

                <p>
                    Each User must authorize the syncing, uploading, or sharing of information from or with any other users or third party websites, applications, or other platforms. Although the Website is available to and may be used in conjunction with other users and third-party products and services, we are not affiliated with, and have no control over, such third parties. Each User must review the privacy policy of, and otherwise do independently assess the security and reliability of each third party’s privacy and data practices.
                </p>

                <p>
                    In the event that The Hunt Agency, LLC or certain of our assets are acquired, user information may be included among the transferred assets.
                </p>

                <p>
                    Although we strive to protect the personal information of our users, we will release personal information if required by law or in the good-faith belief that such action is necessary. We follow the law whenever we receive requests about one or more Users from a governmental entity or related to a lawsuit. We will notify affected Users in when we are asked to disclose their personally identifiable information in this way unless we are legally prohibited from doing so. When we receive requests like this, we will only release a User’s personally identifiable information if we have a good faith belief that disclosure is necessary or appropriate under applicable law. Nothing in this policy is intended to limit any legal defenses or objections that a User may have to a third party's request to disclose the User’s information.
                </p>

                <H3>SECURITY</H3>
                <p>
                    We have adopted security measures to protect against the loss, misuse and/or unauthorized alteration of the information under our control or under the control of our service providers. Our security measures include, but are not limited to: firewalls, passwords and restricted physical access to the places where information is stored. Although we use industry standard practices to protect privacy, we do not promise, and a User should not expect, that personal information or private communications will always remain free from security issues. In the event of a security breach involving Users’ personal information, we will make any legally required disclosures in the most expedient time possible and without unreasonable delay, consistent with the legitimate interests of law enforcement, or any measures necessary to determine the scope of the breach and restore the reasonable integrity of the data system.
                </p>

                <H3>LINKS TO OTHER WEBSITES</H3>
                <p>
                    The Website may contain links to other websites. We do not have control over third party links, and each User should exercise caution and review the privacy statement applicable to the website in question.
                </p>


                <H3>USER ACCESS TO AND CONTROL OVER INFORMATION</H3>
                You may opt out of future contact with us at any time. If you choose to make certain information available to other users, but later wish to opt out and withdraw such consent, you may do so via Account Settings. You may also contact us directly via email at any time to:
                <ul>
                    <li>See the data we have on file for you, if any.</li>
                    <li>Change or correct any data we have for you.</li>
                    <li>Require that we delete part or all of your data.</li>
                    <li>Express any concern that you have about our use of your data.</li>
                </ul>

                <p>
                    As part of our default settings, we send emails to our users. To avoid receiving such emails in the future, a User may opt-out of receiving it by using the unsubscribe feature on any of our email correspondence or by opting out of such direct notices via Account Settings.
                </p>

                <H3>OTHER PROVISIONS REQUIRED BY LAW</H3>
                <p>
                    The laws and rules that govern privacy practices change frequently. Other provisions and practices may apply to your use of the Website as a result of laws, international treaties, or industry practices. It is up to you to determine whether additional practices must be followed or if additional disclosures are required. If you believe that we are not abiding by this Privacy Policy or by any other law, rule, or other regulation that applies to us, you must contact us immediately at: <A href="mailto:catherine@thehunt.agency">catherine@thehunt.agency</A>.
                </p>

                <H3>AMENDMENTS TO POLICY</H3>
                <p>
                    Please note this Privacy Policy will change from time to time. We may amend this Privacy Policy at any time by posting the amended terms on the Website. All amended terms are automatically effective as of the date they are posted. If we make any material changes to our Privacy Policy that affect user information already stored in our database, we will post a notice on our Website notifying users that our Privacy Policy has changed.
                </p>

                <p>
                    Contact us with questions about any of the provisions described above at <A href="mailto:catherine@thehunt.agency">catherine@thehunt.agency</A>.
                </p>



            </PageContent>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Legal/PrivacyPolicy/index.js